import React from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { ReactComponent as WarningIcon } from '../_images/exclamation-triangle.svg';
import PopupConfirmation from "./PopupConfirmation";

function PopupConfirmationWarning({ show, text, onHide, onConfirm }) {
    function getIcon() {
        return <WarningIcon fill="yellow" width={48} height={48} />;
    }

    return (
        <PopupConfirmation show={show} text={text} onHide={onHide} onConfirm={onConfirm} icon={getIcon()} />
    );
}

export default PopupConfirmationWarning
